import { render, staticRenderFns } from "./WeChatBack.vue?vue&type=template&id=5ec17cd4&"
import script from "./WeChatBack.vue?vue&type=script&lang=js&"
export * from "./WeChatBack.vue?vue&type=script&lang=js&"
import style0 from "./WeChatBack.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WeChatBack.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports